import PATHS, { BSH_PATH } from './constants/paths';

export default {
  record: `${BSH_PATH}/${PATHS.record}`,
  film: `${BSH_PATH}/${PATHS.film}`,
  upload: `${BSH_PATH}/${PATHS.upload}`,
  listen: (code) => `${BSH_PATH}/${code}`,
};
